var menu_trigger = document.querySelector('.nav__toggle'),
    nav = document.querySelector('.nav'),
    body = document.querySelector('body'),
    nav_icon = document.querySelectorAll('.mega-nav__trigger'),
    sub_icon = document.querySelectorAll('.nav__icon--sub');

if (menu_trigger !== null) {
    menu_trigger.addEventListener('click', function () {
        // Toggle classes
        menu_trigger.classList.toggle('nav__toggle--active')
        nav.classList.toggle('nav--active')
        body.classList.toggle('overflow--hidden')
        body.classList.toggle('nav--open')

        // Accessibility
        if (menu_trigger.getAttribute('aria-expanded') === 'true') {
            menu_trigger.setAttribute('aria-expanded', 'false')
        } else {
            menu_trigger.setAttribute('aria-expanded', 'true')
        }
    });
}